import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Box,
  Button,
  Typography,
  IconButton,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const AgencyDialog = ({ isOpen, onClose, submitChange, popupData, setPopupData }) => {
  const isSubmitDisabled =
    !popupData?.agencyData.trim() ||
    !popupData?.agencyCodeData.trim() ||
    !popupData?.shortCodeData.trim();

  const handleInputChange = (field, value) => {
    setPopupData((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };

  const Submit = () => {
    submitChange();
  };

  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="sm">
      {/* Header */}
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" fontWeight={500}>
            Add Agency
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      {/* Content */}
      <DialogContent>
        <Grid container spacing={2}>
          {/* Agency Name */}
          <Grid item xs={12}>
            <Typography fontWeight={600}>Agency Name</Typography>
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              value={popupData.agencyData}
              onChange={(e) => handleInputChange("agencyData", e.target.value)}
            />
          </Grid>

          {/* Short Name */}
          <Grid item xs={12} sm={6}>
            <Typography fontWeight={600}>Short Name *</Typography>
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              value={popupData.shortCodeData}
              onChange={(e) => handleInputChange("shortCodeData", e.target.value)}
            />
          </Grid>

          {/* Agency Code */}
          <Grid item xs={12} sm={6}>
            <Typography fontWeight={600}>Agency Code *</Typography>
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              value={popupData.agencyCodeData}
              onChange={(e) => handleInputChange("agencyCodeData", e.target.value)}
            />
          </Grid>
        </Grid>
      </DialogContent>

      {/* Actions */}
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          disabled={isSubmitDisabled}
          onClick={Submit}
          sx={{
            padding: "10px",
            backgroundColor: isSubmitDisabled ? "lightGray" : " #212129",
            color: "white",
            borderRadius: "20px",
            "&:hover": {
              backgroundColor: isSubmitDisabled ? "lightGray" : "darkgray",
            },
          }}
        >
          Ok
        </Button>

        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            padding: "10px",
            border: "1px solid  #212129",
            color: " #212129",
            backgroundColor: "white",
            borderRadius: "20px",
          }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AgencyDialog;
